var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSticky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10 10 L 190 10 L 190 160 L 160 160 L 160 190 L 10 190 Z",
    fill: "#94FF94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 160 160 L 190 160 L 160 190 Z",
    fill: "#56FF56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticky);
export default __webpack_public_path__ + "static/media/Sticky.15003998f47a82c1d9353f31551705df.svg";
export { ForwardRef as ReactComponent };